import { render, staticRenderFns } from "./tab5 copy.vue?vue&type=template&id=1aa788b1&scoped=true&"
import script from "./tab5 copy.vue?vue&type=script&lang=js&"
export * from "./tab5 copy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa788b1",
  null
  
)

export default component.exports